import j_01_01 from "Assets/svg/shapes/j_01_01.svg";
import d_02_01 from "Assets/svg/shapes/d_02_01.svg";
import h_01 from "Assets/svg/shapes/h_01.svg";
import u_04 from "Assets/svg/shapes/u_04.svg";
import w_01 from "Assets/svg/shapes/w_01.svg";
import j_01 from "Assets/svg/shapes/j_01.svg";
import b_01 from "Assets/svg/shapes/b_01.svg";
import d_01_01 from "Assets/svg/shapes/d_01_01.svg";
import a_01_01 from "Assets/svg/shapes/a_01_01.svg";
import a_05_01 from "Assets/svg/shapes/a_05_01.svg";
import a_15_01 from "Assets/svg/shapes/a_15_01.svg";
import a_19_01 from "Assets/svg/shapes/a_19_01.svg";
import f_01 from "Assets/svg/shapes/f_01.svg";
import i_01 from "Assets/svg/shapes/i_01.svg";
import c_01 from "Assets/svg/shapes/c_01.svg";
import f_01_01 from "Assets/svg/shapes/f_01_01.svg";
import b_05_01 from "Assets/svg/shapes/b_05_01.svg";
import e_01 from "Assets/svg/shapes/e_01.svg";
import q_01 from "Assets/svg/shapes/q_01.svg";
import O_01 from "Assets/svg/shapes/O_01.svg";
import n_01_01 from "Assets/svg/shapes/n_01_01.svg";
import b_01_01 from "Assets/svg/shapes/b_01_01.svg";
import c_01_01 from "Assets/svg/shapes/c_01_01.svg";
import b_10_01 from "Assets/svg/shapes/b_10_01.svg";
import k_01_01 from "Assets/svg/shapes/k_01_01.svg";
import L_01 from "Assets/svg/shapes/L_01.svg";
import g_01 from "Assets/svg/shapes/g_01.svg";
import t_01 from "Assets/svg/shapes/t_01.svg";
import k_01 from "Assets/svg/shapes/k_01.svg";
import r_01 from "Assets/svg/shapes/r_01.svg";
import a_01 from "Assets/svg/shapes/a_01.svg";
import e_01_01 from "Assets/svg/shapes/e_01_01.svg";
import d_02_02 from "Assets/svg/shapes/d_02_02.svg";
import d_02_03 from "Assets/svg/shapes/d_02_03.svg";
import d_02_04 from "Assets/svg/shapes/d_02_04.svg";
import h_02 from "Assets/svg/shapes/h_02.svg";
import b_04 from "Assets/svg/shapes/b_04.svg";
import b_02 from "Assets/svg/shapes/b_02.svg";
import b_03 from "Assets/svg/shapes/b_03.svg";
import u_01 from "Assets/svg/shapes/u_01.svg";
import u_03 from "Assets/svg/shapes/u_03.svg";
import u_02 from "Assets/svg/shapes/u_02.svg";
import w_02 from "Assets/svg/shapes/w_02.svg";
import j_02 from "Assets/svg/shapes/j_02.svg";
import d_01_02 from "Assets/svg/shapes/d_01_02.svg";
import d_01_03 from "Assets/svg/shapes/d_01_03.svg";
import d_01_04 from "Assets/svg/shapes/d_01_04.svg";
import a_01_02 from "Assets/svg/shapes/a_01_02.svg";
import a_01_03 from "Assets/svg/shapes/a_01_03.svg";
import a_01_04 from "Assets/svg/shapes/a_01_04.svg";
import a_05_02 from "Assets/svg/shapes/a_05_02.svg";
import a_05_03 from "Assets/svg/shapes/a_05_03.svg";
import a_05_04 from "Assets/svg/shapes/a_05_04.svg";
import e_01_02 from "Assets/svg/shapes/e_01_02.svg";
import e_01_03 from "Assets/svg/shapes/e_01_03.svg";
import e_01_04 from "Assets/svg/shapes/e_01_04.svg";
import a_02 from "Assets/svg/shapes/a_02.svg";
import a_03 from "Assets/svg/shapes/a_03.svg";
import a_04 from "Assets/svg/shapes/a_04.svg";
import r_02 from "Assets/svg/shapes/r_02.svg";
import k_02 from "Assets/svg/shapes/k_02.svg";
import t_02 from "Assets/svg/shapes/t_02.svg";
import t_03 from "Assets/svg/shapes/t_03.svg";
import t_04 from "Assets/svg/shapes/t_04.svg";
import g_02 from "Assets/svg/shapes/g_02.svg";
import g_03 from "Assets/svg/shapes/g_03.svg";
import g_04 from "Assets/svg/shapes/g_04.svg";
import m_01 from "Assets/svg/shapes/m_01.svg";
import i_01_01 from "Assets/svg/shapes/i_01_01.svg";
import b_10_02 from "Assets/svg/shapes/b_10_02.svg";
import b_10_03 from "Assets/svg/shapes/b_10_03.svg";
import b_10_04 from "Assets/svg/shapes/b_10_04.svg";
import c_01_02 from "Assets/svg/shapes/c_01_02.svg";
import c_01_03 from "Assets/svg/shapes/c_01_03.svg";
import c_01_04 from "Assets/svg/shapes/c_01_04.svg";
import b_01_02 from "Assets/svg/shapes/b_01_02.svg";
import b_01_03 from "Assets/svg/shapes/b_01_03.svg";
import b_01_04 from "Assets/svg/shapes/b_01_04.svg";
import n_01_02 from "Assets/svg/shapes/n_01_02.svg";
import n_01_03 from "Assets/svg/shapes/n_01_03.svg";
import n_01_04 from "Assets/svg/shapes/n_01_04.svg";
import O_02 from "Assets/svg/shapes/O_02.svg";
import O_03 from "Assets/svg/shapes/O_03.svg";
import O_04 from "Assets/svg/shapes/O_04.svg";
import p_01 from "Assets/svg/shapes/p_01.svg";
import s_01 from "Assets/svg/shapes/s_01.svg";
import b_05_02 from "Assets/svg/shapes/b_05_02.svg";
import b_05_03 from "Assets/svg/shapes/b_05_03.svg";
import b_05_04 from "Assets/svg/shapes/b_05_04.svg";
import f_01_02 from "Assets/svg/shapes/f_01_02.svg";
import f_01_03 from "Assets/svg/shapes/f_01_03.svg";
import f_01_04 from "Assets/svg/shapes/f_01_04.svg";
import c_02 from "Assets/svg/shapes/c_02.svg";
import c_03 from "Assets/svg/shapes/c_03.svg";
import c_04 from "Assets/svg/shapes/c_04.svg";
import i_03 from "Assets/svg/shapes/i_03.svg";
import i_04 from "Assets/svg/shapes/i_04.svg";
import f_02 from "Assets/svg/shapes/f_02.svg";
import f_03 from "Assets/svg/shapes/f_03.svg";
import f_04 from "Assets/svg/shapes/f_04.svg";
import a_19_02 from "Assets/svg/shapes/a_19_02.svg";
import a_19_03 from "Assets/svg/shapes/a_19_03.svg";
import a_19_04 from "Assets/svg/shapes/a_19_04.svg";
import a_15_02 from "Assets/svg/shapes/a_15_02.svg";
import a_15_03 from "Assets/svg/shapes/a_15_03.svg";
import a_15_04 from "Assets/svg/shapes/a_15_04.svg";

export default {
  rectangle: [
    {
      sub: [
        {
          title: "Rectangle",//"مستطیل",
          icon: j_01_01,
          key: "j_01_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)#[(3.y)/(20)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#[(2.x)/(20)]",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ]
        },
        {
          title: "Two_rectangles_inside_each_other_1",//"دو مستطیل داخل هم 1",
          icon: d_02_01,
          key: "d_02_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(2.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(2.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_rectangles_inside_each_other_2",//"دو مستطیل داخل هم 2",
          icon: d_02_02,
          key: "d_02_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(1.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(2.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(1.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(2.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_rectangles_inside_each_other_3",//"دو مستطیل داخل هم 3",
          icon: d_02_03,
          key: "d_02_03",
          str1: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_rectangles_inside_each_other_4",//"دو مستطیل داخل هم 4",
          icon: d_02_04,
          key: "d_02_04",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  eye: [
    {
      sub: [
        { title: "Horizontal_eye",//"چشمی افقی",
          icon: h_01,
          key: "h_01",
          str1: [
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "1000,1500",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(1.C)@[(1.x)/(2)]&(1.C)>[(1.x)/(10)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,1000",
              Ctrlpoint: "1000,500",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "(1.C)",
              Z: "0",
              Iff: "(1.C)#(100)",
            },
          ],
          str2: [
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "1000,1500",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,1000",
              Ctrlpoint: "1000,500",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
          ]},
        {
          title: "Vertical_eye",//"چشمی عمودی",
          icon: h_02,
          key: "h_02",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "1000,2000",
              Ctrlpoint: "500,1000",
              Model: "ARC",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.C)@[(1.y)/(2)]&(1.C)>[(1.y)/(10)]",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "1500,1000",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "(1.C)#(100)",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "1000,2000",
              Ctrlpoint: "500,1000",
              Model: "ARC",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "1500,1000",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  doGoosheKhamGroup: [
    {
      sub: [
        {  title: "Two_bent_corners_1",//"دو گوشه خم 1",
          icon: b_04,
          key: "b_04",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.x)>[(1.y)/(15)]&(1.y)>[(1.x)/(15)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "148,1852",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "(1.C)@[(1.y)*(293)/(1000)]",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)@[(1.x)*(293)/(1000)]",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(1.y)+(2.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "148,1852",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(1.y)+(2.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ]},
        {
          title: "Two_bent_corners_2",//"دو گوشه خم 2",
          icon: b_02,
          key: "b_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(4.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "(5.x)>[(5.y)/(15)]&(5.y)>[(5.x)/(15)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(5.C)#[(5.y)/(10)]|(5.C)#[(5.x)/(10)]",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1000,1500",
              Ctrlpoint: "853,1853",
              Model: "ARC",
              Code: 3,
              X: "(5.x)",
              Y: "(5.y)",
              C: "(5.C)",
              Z: "0",
              Iff: "(5.C)@[(5.y)*(293)/(1000)]",
            },
            {
              Startpoint: "1000,1500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(5.C)@[(5.x)*(293)/(1000)]",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "500,0",
              Ctrlpoint: "853,146",
              Model: "ARC",
              Code: 5,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(4.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1000,1500",
              Ctrlpoint: "853,1853",
              Model: "ARC",
              Code: 3,
              X: "(5.x)",
              Y: "(5.y)",
              C: "(5.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "500,0",
              Ctrlpoint: "853,146",
              Model: "ARC",
              Code: 5,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_3",//"دو گوشه خم 3",
          icon: b_03,
          key: "b_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)/(15)]&(2.y)>[(2.x)/(15)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "500,1000",
              Ctrlpoint: "146,853",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(2.C)#[(2.y)/(10)]|(2.C)#[(2.x)/(10)]",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.C)@[(2.y)*(293)/(1000)]",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "1855,853",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "(2.C)@[(2.x)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(2.x)+(3.x)+(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "500,1000",
              Ctrlpoint: "146,853",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "1855,853",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(2.x)+(3.x)+(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_4",//"دو گوشه خم 4",
          icon: b_01,
          key: "b_01",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.x)>[(1.y)/(15)]&(1.y)>[(1.x)/(15)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(6.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)@[(1.y)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "(1.C)@[(1.x)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1852,148",
              Model: "ARC",
              Code: 5,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(6.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1852,148",
              Model: "ARC",
              Code: 5,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  doGoosheKameMokhalefGroup: [
    {
      sub: [
        {
          title: "Two_bent_corners_u4",//"دو گوشه خم u4",
          icon: u_04,
          key: "u_04",
          str1: [
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.x)#[(4.y)/(5)]&(4.y)#[(4.x)/(5)]",
            },
            {
              Startpoint: "0,0",
              Endpoint: "500,500",
              Ctrlpoint: "155,345",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "(4.C)@[(4.x)*(27)/(100)]&(4.C)@[(4.y)*(27)/(100)]",
            },
            {
              Startpoint: "500,500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.C)#[(4.x)/(7)]|(4.C)#[(4.y)/(7)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1840,155",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "500,500",
              Ctrlpoint: "155,345",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1840,155",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_u1",//"دو گوشه خم u1",
          icon: u_01,
          key: "u_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "1500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)#[(2.y)/(5)]&(2.y)#[(2.x)/(5)]",
            },
            {
              Startpoint: "1500,500",
              Endpoint: "2000,0",
              Ctrlpoint: "1813,313",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(2.C)@[(2.x)*(27)/(100)]&(2.C)@[(2.y)*(27)/(100)]",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.C)#[(2.x)/(7)]|(2.C)#[(2.y)/(7)]",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "186,186",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "500,500",
              Ctrlpoint: "155,345",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1840,155",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_u3",//"دو گوشه خم u3",
          icon: u_03,
          key: "u_03",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)#[(2.y)/(5)]&(2.y)#[(2.x)/(5)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "500,1500",
              Ctrlpoint: "320,1820",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(2.C)@[(2.x)*(27)/(100)]&(2.C)@[(2.y)*(27)/(100)]",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.C)#[(2.x)/(7)]|(2.C)#[(2.y)/(7)]",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "180,180",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "500,1500",
              Ctrlpoint: "320,1820",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "180,180",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_u3",//"دو گوشه خم u3",
          icon: u_02,
          key: "u_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(4.x)#[(4.y)/(5)]&(4.y)#[(4.x)/(5)]",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "180,1820",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "(4.C)@[(4.x)*(27)/(100)]&(4.C)@[(4.y)*(27)/(100)]",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(4.C)#[(4.x)/(7)]|(4.C)#[(4.y)/(7)]",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,0",
              Ctrlpoint: "320,180",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "180,1820",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,0",
              Ctrlpoint: "320,180",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  doGoosheKhamDotarafeGroup: [
    {
      sub: [
        {   title: "Two_bent_corners_4",//"دو گوشه خم 4",
          icon: w_01,
          key: "w_01",
          str1: [
            {
              Startpoint: "500,500",
              Endpoint: "1500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1750,250",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(2.C)#[(2.y)/(10)]&(2.C)@[(2.y)/(2)]",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,500",
              Ctrlpoint: "250,250",
              Model: "ARC",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,500",
              Endpoint: "1500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1750,250",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,500",
              Ctrlpoint: "250,250",
              Model: "ARC",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_5",//"دو گوشه خم 5",
          icon: w_02,
          key: "w_02",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "1000,1500",
              Ctrlpoint: "500,2000",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(2.C)#[(2.x)/(10)]&(2.C)@[(2.x)/(2)]",
            },
            {
              Startpoint: "1000,1500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,500",
              Ctrlpoint: "500,0",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,1500",
              Ctrlpoint: "250,1750",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,500",
              Ctrlpoint: "250,250",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  doGoosheKhamBaErtefaGroup: [
    {
      sub: [
        {
          title: "Two_bent_corners_j1",//"دو گوشه خم j1",
          icon: j_01,
          key: "j_01",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "155,155",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.C)@[(1.y)*(27)/(100)]&(1.C)@[(1.x)*(27)/(100)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.y)>[(1.y)/(6)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "1844,844",
              Model: "ARC",
              Code: 4,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "(6.x)>[(1.x)/(6)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "155,155",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "1844,844",
              Model: "ARC",
              Code: 4,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_bent_corners_j2",//"دو گوشه خم j2",
          icon: j_02,
          key: "j_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.C)@[(2.y)*(27)/(100)]&(2.C)@[(2.x)*(27)/(100)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "500,1000",
              Ctrlpoint: "155,844",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.y)>[(2.y)/(6)]",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.C)#[(2.y)/(10)]|(2.C)#[(2.x)/(10)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "(3.x)>[(2.x)/(6)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1844,155",
              Model: "ARC",
              Code: 5,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "500,1000",
              Ctrlpoint: "155,844",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1844,155",
              Model: "ARC",
              Code: 5,
              X: "(2.x)",
              Y: "(2.y)",
              C: "(2.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  doGoosheMovarabGroup: [
    {
      sub: [
        {
          title: "Two_diagonal_corners_1",//"دو گوشه مورب 1",
          icon: d_01_01,
          key: "d_01_01",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(6.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(6.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_diagonal_corners_2",//"دو گوشه مورب 2",
          icon: d_01_02,
          key: "d_01_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(5.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(5.x)",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(5.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(5.x)",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_diagonal_corners_3",//"دو گوشه مورب 3",
          icon: d_01_03,
          key: "d_01_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(4.x)+(3.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(4.x)+(3.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Two_diagonal_corners_4",//"دو گوشه مورب 4",
          icon: d_01_04,
          key: "d_01_04",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(3.y)+(2.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(3.y)+(2.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  zozanagheOfoghi: [
    {
      sub: [
        {
          title: "Horizontal_trapezoid_1",//"ذوزنقه افقی 1",
          icon: a_01_01,
          key: "a_01_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)#(4.x)&(4.x)#(200)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)-(4.x)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#[(3.x)*(55)/(100)]&(3.x)#(100)",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)-(4.x)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Horizontal_Trapezoid_2",//"ذوزنقه افقی 2",
          icon: a_01_02,
          key: "a_01_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(4.x)-(2.x)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)>[(3.x)*(55)/(100)]&(3.x)#(100)",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.x)#(2.x)&(2.x)#(200)",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(4.x)-(2.x)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Horizontal_Trapezoid_3",//"ذوزنقه افقی 3",
          icon: a_01_03,
          key: "a_01_03",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)-(4.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#(100)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)#(4.x)&(4.x)#(200)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)-(4.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Horizontal_Trapezoid_4",//"ذوزنقه افقی 4",
          icon: a_01_04,
          key: "a_01_04",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)-(2.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#(100)",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.x)#(2.x)&(2.x)#(200)",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)-(2.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  zozanagheAmoodi: [
    {
      sub: [
        {
          title: "Vertical_Trapezoid_1",//"ذوزنقه عمودی 1",
          icon: a_05_01,
          key: "a_05_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.y)#(3.y)&(3.y)#(200)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(1.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "(4.x)>[(4.y)*(55)/(100)]&(4.y)#(100)",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(1.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Vertical_Trapezoid_2",//"ذوزنقه عمودی 2",
          icon: a_05_02,
          key: "a_05_02",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#(1.y)&(1.y)#(200)",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(3.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "(4.x)>[(4.y)*(55)/(100)]&(4.y)#(100)",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(3.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Vertical_Trapezoid_3",//"ذوزنقه عمودی 3",
          icon: a_05_03,
          key: "a_05_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)#(3.y)&(3.y)#(200)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(1.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#(100)",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(1.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Vertical_Trapezoid_4",//"ذوزنقه عمودی 4",
          icon: a_05_04,
          key: "a_05_04",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(3.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#(100)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#(1.y)&(1.y)#(200)",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(3.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  zozanagheMotasaviolSaghayn: [
    {
      sub: [
        {
          title: "Isosceles_Trapezoid_1",//"ذوزنقه متساوی الساقین 1",
          icon: a_15_01,
          key: "a_15_01",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)-(4.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#(100)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)#(4.x)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)-(4.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Isosceles_Trapezoid_2",//"ذوزنقه متساوی الساقین 2",
          icon: a_15_02,
          key: "a_15_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)#(3.y)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(1.y)-(3.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(51)/(100)]&(2.y)#(100)",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(1.y)-(3.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Isosceles_Trapezoid_3",//"ذوزنقه متساوی الساقین 3",
          icon: a_15_03,
          key: "a_15_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)-(2.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(51)/(100)]&(1.x)#(100)",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.x)#(2.x)",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)-(2.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Isosceles_Trapezoid_4",//"ذوزنقه متساوی الساقین 4",
          icon: a_15_04,
          key: "a_15_04",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(3.y)-(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(51)/(100)]&(2.y)#(100)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#(1.y)",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(3.y)-(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  zozanagheMokhtalefolAzla: [
    {
      sub: [
        {
          title: "Various_Sided_Trapezoid_1",//"ذوزنقه مختلف اضلاع 1",
          icon: a_19_01,
          key: "a_19_01",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)-(4.x)-(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#(100)&(3.y)>[(3.x)*(55)/(100)]&(3.x)#(100)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)#(4.x)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)-(4.x)-(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Various_Sided_Trapezoid_2",//"ذوزنقه مختلف اضلاع 2",
          icon: a_19_02,
          key: "a_19_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)#(3.y)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#(100)&(4.x)>[(4.y)*(55)/(100)]&(4.y)#(100)",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(1.y)-(2.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(1.y)-(2.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Various_Sided_Trapezoid_3",//"ذوزنقه مختلف اضلاع 3",
          icon: a_19_03,
          key: "a_19_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)-(2.x)-(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#(100)&(3.y)>[(3.x)*(55)/(100)]&(3.x)#(100)",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.x)#(2.x)",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)-(2.x)-(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Various_Sided_Trapezoid_4",//"ذوزنقه مختلف اضلاع 4",
          icon: a_19_04,
          key: "a_19_04",
          str1: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#(100)&(4.x)>[(4.y)*(55)/(100)]&(4.y)#(100)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#(1.y)",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(3.y)-(2.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(3.y)-(2.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  robDayere: [
    {
      sub: [
        {
          title: "Quarter_Circle_1",//"ربع دایره 1",
          icon: f_01,
          key: "f_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "0,0",
              Ctrlpoint: "1414,585",
              Model: "ARC",
              Code: 3,
              X: "(2.x)",
              Y: "(2.x)",
              C: "(2.x)*(293)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "0,0",
              Ctrlpoint: "1414,585",
              Model: "ARC",
              Code: 3,
              X: "(2.x)",
              Y: "(2.x)",
              C: "(2.x)*(293)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Quarter_Circle_2",//"ربع دایره 2",
          icon: f_02,
          key: "f_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "1414,1414",
              Model: "ARC",
              Code: 2,
              X: "(3.x)",
              Y: "(3.x)",
              C: "(3.x)*(292)/(1000)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "1414,1414",
              Model: "ARC",
              Code: 2,
              X: "(3.x)",
              Y: "(3.x)",
              C: "(3.x)*(292)/(1000)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Quarter_Circle_3",//"ربع دایره 3",
          icon: f_03,
          key: "f_03",
          str1: [
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "2000,2000",
              Ctrlpoint: "585,1414",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "(1.x)",
              C: "(1.x)*(292)/(1000)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "2000,2000",
              Ctrlpoint: "585,1414",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "(1.x)",
              C: "(1.x)*(292)/(1000)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Quarter_Circle_4",//"ربع دایره 4",
          icon: f_04,
          key: "f_04",
          str1: [
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "(1.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,2000",
              Ctrlpoint: "585,585",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.x)",
              C: "(1.x)*(292)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "(1.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,2000",
              Ctrlpoint: "585,585",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.x)",
              C: "(1.x)*(292)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  robDayereBaTanzimeGhos: [
    {
      sub: [
        {
          title: "Quarter_Circle_with_Arc_Adjustment_1",//"ربع دایره با تنظیم قوس 1",
          icon: i_01,
          key: "i_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)#[(2.x)/(4)]&(2.x)#[(1.y)/(4)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(3.C)#[(2.x)/(10)]|(3.C)#[(1.y)/(10)]",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,0",
              Ctrlpoint: "500,125",
              Model: "ARC",
              Code: 3,
              X: "(2.x)",
              Y: "(1.y)",
              C: "-1",
              Z: "0",
              Iff: "(3.C)@[(2.x)*(27)/(100)]&(3.C)@[(1.y)*(27)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,0",
              Ctrlpoint: "500,125",
              Model: "ARC",
              Code: 3,
              X: "(2.x)",
              Y: "(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Quarter_circle_with_arc_adjustment_3",//"ربع دایره با تنظیم قوس 3",
          icon: i_03,
          key: "i_03",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(3.y)#[(1.x)/(4)]&(1.x)#[(3.y)/(4)]",
            },
            {
              Startpoint: "0,0",
              Endpoint: "1000,500",
              Ctrlpoint: "450,370",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "(3.y)",
              C: "-1",
              Z: "0",
              Iff: "(2.C)#[(1.x)/(10)]|(2.C)#[(2.y)/(10)]",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.C)@[(1.x)*(27)/(100)]&(2.C)@[(3.y)*(27)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "1000,500",
              Ctrlpoint: "450,370",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "(3.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Quarter_circle_with_arc_adjustment_4",//"ربع دایره با تنظیم قوس 4",
          icon: i_04,
          key: "i_04",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.y)#[(1.x)/(4)]&(1.x)#[(2.y)/(4)]",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.C)#[(1.x)/(10)]|(3.C)#[(2.y)/(10)]",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,500",
              Ctrlpoint: "450,130",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(2.y)",
              C: "-1",
              Z: "0",
              Iff: "(3.C)@[(1.x)*(27)/(100)]&(3.C)@[(2.y)*(27)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,500",
              Ctrlpoint: "450,130",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(2.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  seGosheKham: [
    {
      sub: [
        {
          title: "Bent_triangle_1",//"سه گوشه خم 1",
          icon: c_01,
          key: "c_01",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "250,75",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.x)>[(7.x)/(15)]&(1.y)>[(5.y)/(15)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "(5.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(7.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)@[(1.x)*(293)/(1000)]",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "1750,1925",
              Model: "ARC",
              Code: 4,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "(1.C)@[(1.y)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1750,75",
              Model: "ARC",
              Code: 6,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "250,75",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "(5.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(7.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "1750,1925",
              Model: "ARC",
              Code: 4,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1750,75",
              Model: "ARC",
              Code: 6,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Bent_triangle_2",//"سه گوشه خم 2",
          icon: c_02,
          key: "c_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(4.y)",
              C: "0",
              Z: "0",
              Iff: "(4.x)>[(4.y)/(15)]&(4.y)>[(4.x)/(15)]&(4.C)@[(4.y)*(29)/(100)]&(4.C)@[(4.x)*(29)/(100)]",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "250,1925",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "(4.C)#[(4.y)/(10)]|(4.C)#[(4.x)/(10)]",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "1750,1925",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1750,75",
              Model: "ARC",
              Code: 6,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(3.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "250,1925",
              Model: "ARC",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "1750,1925",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1750,75",
              Model: "ARC",
              Code: 6,
              X: "(4.x)",
              Y: "(4.y)",
              C: "(4.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(3.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Bent_triangle_3",//"سه گوشه خم 3",
          icon: c_03,
          key: "c_03",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "146,146",
              Model: "ARC",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "(3.C)",
              Z: "0",
              Iff: "(3.x)>[(3.y)/(15)]&(3.y)>[(3.x)/(15)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.C)#[(1.y)/(10)]|(3.C)#[(3.x)/(10)]",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "146,1853",
              Model: "ARC",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(3.C)@[(3.y)*(293)/(1000)]",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(3.C)@[(3.x)*(293)/(1000)]",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "1853,1853",
              Model: "ARC",
              Code: 5,
              X: "(3.x)",
              Y: "(3.y)",
              C: "(3.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "0",
              Y: "(2.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(4.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "146,146",
              Model: "ARC",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "(3.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "146,1853",
              Model: "ARC",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "1853,1853",
              Model: "ARC",
              Code: 5,
              X: "(3.x)",
              Y: "(3.y)",
              C: "(3.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "0",
              Y: "(2.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(4.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Bent_triangle_4",//"سه گوشه خم 4",
          icon: c_04,
          key: "c_04",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.x)>[(1.y)/(15)]&(1.y)>[(1.x)/(15)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "148,1852",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "(1.C)@[(1.y)*(293)/(1000)]",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(7.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)@[(1.x)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(2.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1852,148",
              Model: "ARC",
              Code: 6,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "148,1852",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(7.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(2.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1852,148",
              Model: "ARC",
              Code: 6,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  seGosheMovarab: [
    {
      sub: [
        {
          title: "Diagonal_triangle_1",//"سه گوشه مورب 1",
          icon: f_01_01,
          key: "f_01_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(5.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(5.x)",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(5.x)",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(5.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(5.x)",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(5.x)",
              Y: "(5.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Diagonal_triangle_2",//"سه گوشه مورب 2",
          icon: f_01_02,
          key: "f_01_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(3.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(5.y)+(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(3.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Diagonal_triangle_3",//"سه گوشه مورب 3",
          icon: f_01_03,
          key: "f_01_03",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "0",
              Y: "(2.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(4.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "0",
              Y: "(2.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "(4.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Diagonal_triangle_4",//"سه گوشه مورب 4",
          icon: f_01_04,
          key: "f_01_04",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(7.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(2.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(7.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "0",
              Y: "(2.y)+(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 7,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  mosalasGhaemolZaviye: [
    {
      sub: [
        {
          title: "Right_triangle_1",//"مثلث قائم الزاویه 1",
          icon: b_05_01,
          key: "b_05_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(1.y)*(49)/(100)]&(1.y)>[(2.x)*(49)/(100)]",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          tilte: "مثلث قائم الزاویه 2",
          icon: b_05_02,
          key: "b_05_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(49)/(100)]&(2.y)>[(2.x)*(49)/(100)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Right_triangle_3",//"مثلث قائم الزاویه 3",
          icon: b_05_03,
          key: "b_05_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(2.y)*(49)/(100)]&(2.y)>[(1.x)*(49)/(100)]",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Right_triangle_4",//"مثلث قائم الزاویه 4",
          icon: b_05_04,
          key: "b_05_04",
          str1: [
            {
              Startpoint: "2000,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(3.y)*(49)/(100)]&(3.y)>[(2.x)*(49)/(100)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "2000,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  kolbeyi: [
    {
      sub: [
        {
          title: "Cottage_1",//"کلبه ای 1",
          icon: e_01,
          key: "e_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(4.C)@[(2.x)/(2)]&(4.C)>[(2.x)/(50)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Cottage_2",//"کلبه ای 2",
          icon: s_01,
          key: "s_01",
          str1: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.y)#(200)",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,1000",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "(2.x)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,1000",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "(2.x)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  kolbeyiGerdi: [
    {
      sub: [
        {
          title: "Round_cottage_1",//"کلبه ای گردی 1",
          icon: q_01,
          key: "q_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)#[(2.x)/(45)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,500",
              Endpoint: "500,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(5.C)#[(5.x)/(10)]&(5.C)@[(5.x)/(2)]",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(6.x)+(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,500",
              Endpoint: "500,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 6,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Round_cottage_2",//"کلبه ای گردی 2",
          icon: p_01,
          key: "p_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)#[(2.x)/(50)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,500",
              Ctrlpoint: "500,0",
              Model: "ARC",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(5.C)#[(5.x)/(10)]&(5.C)@[(5.x)/(2)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,500",
              Ctrlpoint: "500,0",
              Model: "ARC",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  kolbeyiMovarab: [
    {
      sub: [
        {
          title: "Diagonal_cottage_1",//"کلبه ای مورب 1",
          icon: O_01,
          key: "O_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)*(23)/(100)]&(1.y)>[(1.x)*(9)/(100)]",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 3,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(3.C)#[(1.x)/(10)]&(3.C)@(1.x)",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 3,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Diagonal_cottage_2",//"کلبه ای مورب 2",
          icon: O_02,
          key: "O_02",
          str1: [
            {
              Startpoint: "1500,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(23)/(100)]&(1.x)>[(1.y)*(9)/(100)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "2000,500",
              Model: "ARC",
              Code: 3,
              X: "0",
              Y: "(1.y)+(1.y)",
              C: "-1",
              Z: "0",
              Iff: "(3.C)#[(1.y)/(10)]&(3.C)@(1.y)",
            },
          ],
          str2: [
            {
              Startpoint: "1500,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "1500,0",
              Ctrlpoint: "2000,500",
              Model: "ARC",
              Code: 3,
              X: "0",
              Y: "(1.y)+(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Diagonal_cottage_3",//"کلبه ای مورب 3",
          icon: O_03,
          key: "O_03",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)*(23)/(100)]&(1.y)>[(1.x)*(9)/(100)]",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,1500",
              Ctrlpoint: "1000,2000",
              Model: "ARC",
              Code: 2,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "(2.C)#[(1.x)/(10)]&(2.C)@(1.x)",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "2000,1500",
              Ctrlpoint: "1000,2000",
              Model: "ARC",
              Code: 2,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Diagonal_cottage_4",//"کلبه ای مورب 4",
          icon: O_04,
          key: "O_04",
          str1: [
            {
              Startpoint: "2000,1000",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(23)/(100)]&(1.x)>[(1.y)*(9)/(100)]",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)+(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "(2.C)#[(1.y)/(10)]&(2.C)@(1.y)",
            },
          ],
          str2: [
            {
              Startpoint: "2000,1000",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)+(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  mosalasMotasaviolAzla: [
    {
      sub: [
        {
          title: "Triangle_Equilateral_1",//"مثلث متساوی الاضلاع 1",
          icon: n_01_01,
          key: "n_01_01",
          str1: [
            {
              Startpoint: "0,866",
              Endpoint: "1000,866",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,866",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)/(2)",
              Y: "(1.x)*(866)/(1000)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,866",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)/(2)",
              Y: "(1.x)*(866)/(1000)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 3,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Equilateral_Triangle_2",//"مثلث متساوی الاضلاع 2",
          icon: n_01_02,
          key: "n_01_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "866,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.y)*(866)/(1000)",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "866,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.y)*(866)/(1000)",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "866,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.y)*(866)/(1000)",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "866,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.y)*(866)/(1000)",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Equilateral_Triangle_3",//"مثلث متساوی الاضلاع 3",
          icon: n_01_03,
          key: "n_01_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "500,866",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)/(2)",
              Y: "(3.x)*(866)/(1000)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,866",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)/(2)",
              Y: "(3.x)*(866)/(1000)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "500,866",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)/(2)",
              Y: "(3.x)*(866)/(1000)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,866",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)/(2)",
              Y: "(3.x)*(866)/(1000)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Equilateral_Triangle_4",//"مثلث متساوی الاضلاع 4",
          icon: n_01_04,
          key: "n_01_04",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "866,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.y)*(866)/(1000)",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "866,1000",
              Endpoint: "866,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "866,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.y)*(866)/(1000)",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "866,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.y)*(866)/(1000)",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "866,1000",
              Endpoint: "866,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "866,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.y)*(866)/(1000)",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  mosalasMotasaviolSaghayn: [
    {
      sub: [
        {
          title: "Isosceles_Triangle_1",//"مثلث متساوی الساقین 1",
          icon: b_01_01,
          key: "b_01_01",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "400,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.y)#(200)",
            },
            {
              Startpoint: "400,2000",
              Endpoint: "1600,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1600,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)/(2)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)*(29)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "400,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(2.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "400,2000",
              Endpoint: "1600,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1600,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)/(2)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Isosceles_Triangle_2",//"مثلث متساوی الساقین 2",
          icon: b_01_02,
          key: "b_01_02",
          str1: [
            {
              Startpoint: "0,400",
              Endpoint: "0,1600",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1600",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#(200)",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,400",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "(2.y)>[(2.x)*(29)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,400",
              Endpoint: "0,1600",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1600",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "0,400",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)",
              Y: "(1.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Isosceles_Triangle_3",//"مثلث متساوی الساقین 3",
          icon: b_01_03,
          key: "b_01_03",
          str1: [
            {
              Startpoint: "400,0",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)/(2)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.y)#(200)",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1600,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1600,0",
              Endpoint: "400,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)*(29)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "400,0",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)/(2)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1600,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)/(2)",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1600,0",
              Endpoint: "400,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Isosceles_Triangle_4",//"مثلث متساوی الساقین 4",
          icon: b_01_04,
          key: "b_01_04",
          str1: [
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1600",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1600",
              Endpoint: "2000,400",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)*(55)/(100)]&(1.y)#(200)",
            },
            {
              Startpoint: "2000,400",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(29)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1600",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1600",
              Endpoint: "2000,400",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,400",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)",
              Y: "(2.y)/(2)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  otavaziolAzla: [
    {
      sub: [
        {
          title: "Parallelogram_1",//"متوازی الاضلاع 1",
          icon: c_01_01,
          key: "c_01_01",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)>[(3.x)*(55)/(100)]",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Parallelogram_2",//"متوازی الاضلاع 2",
          icon: c_01_02,
          key: "c_01_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Parallelogram_3",//"متوازی الاضلاع 3",
          icon: c_01_03,
          key: "c_01_03",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]",
            },
            {
              Startpoint: "1000,1500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1500",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Parallelogram_4",//"متوازی الاضلاع 4",
          icon: c_01_04,
          key: "c_01_04",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)>[(3.x)*(55)/(100)]",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(3.x)",
              Y: "(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  mosalasMokhtalefolAzla: [
    {
      sub: [
        {
          title: "Segmented_Triangle_1",//"مثلث مختلف الاضلاع 1",
          icon: b_10_01,
          key: "b_10_01",
          str1: [
            {
              Startpoint: "800,0",
              Endpoint: "0,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#[(1.y)*(23)/(100)]",
            },
            {
              Startpoint: "0,800",
              Endpoint: "2000,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,800",
              Endpoint: "800,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)-(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "(3.y)>[(3.x)*(55)/(100)]&(3.x)#[(3.y)*(23)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "800,0",
              Endpoint: "0,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,800",
              Endpoint: "2000,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,800",
              Endpoint: "800,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(2.x)-(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Segmented_Triangle_2",//"مثلث مختلف الاضلاع 2",
          icon: b_10_02,
          key: "b_10_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "800,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)",
              Y: "(1.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#[(2.x)*(23)/(100)]",
            },
            {
              Startpoint: "800,800",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.x)>[(3.y)*(55)/(100)]&(3.y)#[(3.x)*(23)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "800,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)",
              Y: "(1.y)-(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "800,800",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Segmented_Triangle_3",//"مثلث مختلف الاضلاع 3",
          icon: b_10_03,
          key: "b_10_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "800,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>[(1.x)*(55)/(100)]&(1.x)#[(1.y)*(23)/(100)]",
            },
            {
              Startpoint: "800,800",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)-(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "(2.y)>[(2.x)*(55)/(100)]&(2.x)#[(2.y)*(23)/(100)]",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "800,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "800,800",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(3.x)-(1.x)",
              Y: "(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Segmented_Triangle_4",//"مثلث مختلف الاضلاع 4",
          icon: b_10_04,
          key: "b_10_04",
          str1: [
            {
              Startpoint: "800,0",
              Endpoint: "0,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)*(55)/(100)]&(1.y)#[(1.x)*(23)/(100)]",
            },
            {
              Startpoint: "0,800",
              Endpoint: "800,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(3.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "(2.x)>[(2.y)*(55)/(100)]&(2.y)#[(2.x)*(23)/(100)]",
            },
            {
              Startpoint: "800,2000",
              Endpoint: "800,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "800,0",
              Endpoint: "0,800",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,800",
              Endpoint: "800,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(1.x)",
              Y: "(3.y)-(1.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "800,2000",
              Endpoint: "800,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  moraba: [
    {
      sub: [
        {
          title: "Square_1",//"مربع 1",
          icon: k_01_01,
          key: "k_01_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "(2.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Square_2",//"مربع 2",
          icon: i_01_01,
          key: "i_01_01",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(4.x)#[(4.y)*(23)/(100)]&(4.y)#[(4.x)*(23)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(4.x)",
              Y: "(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  masjedi: [
    {
      sub: [
        {title: "Mosque_1",//"مسجدی 1",
          icon: L_01,
          key: "L_01",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "300,400",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.x)#[(1.y)*(13)/(100)]&(1.y)#[(1.x)*(9)/(100)]&(1.C)@[(1.y)*(29)/(100)]&(1.C)@[(1.x)*(29)/(100)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "1700,400",
              Model: "ARC",
              Code: 5,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "300,400",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(1.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "1700,400",
              Model: "ARC",
              Code: 5,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
          ]},
        {
          title: "Mosque_2",//"مسجدی 2",
          icon: m_01,
          key: "m_01",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "300,400",
              Model: "ARC",
              Code: 1,
              X: "(2.x)/(2)",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.y)#[(1.x)*(23)/(100)]&(1.x)#[(1.y)*(13)/(100)]&(1.C)@[(1.y)*(29)/(100)]&(1.C)@[(1.x)*(29)/(100)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "1700,400",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "300,400",
              Model: "ARC",
              Code: 1,
              X: "(2.x)/(2)",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "1000,0",
              Ctrlpoint: "1700,400",
              Model: "ARC",
              Code: 3,
              X: "(1.x)",
              Y: "(1.y)",
              C: "(1.C)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  nimdayereBaTanzim: [
    {
      sub: [
        {
          title: "Semicircle_with_adjustment_1",//"نیم دایره با تنظیم 1",
          icon: g_01,
          key: "g_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.C)#(200)",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(2.C)@[(1.x)/(2)]&(2.C)>[(1.x)/(8)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "0,500",
              Ctrlpoint: "1000,0",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Semicircle_with_adjustment_2",//"نیم دایره با تنظیم 2",
          icon: g_02,
          key: "g_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.C)#(200)",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "0,0",
              Ctrlpoint: "500,1000",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "-1",
              Z: "0",
              Iff: "(2.C)@[(1.y)/(2)]&(2.C)>[(1.y)/(7)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "0,0",
              Ctrlpoint: "500,1000",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Semicircle_with_adjustment_3",//"نیم دایره با تنظیم 3",
          icon: g_03,
          key: "g_03",
          str1: [
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.C)#(200)",
            },
            {
              Startpoint: "0,0",
              Endpoint: "2000,0",
              Ctrlpoint: "1000,500",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "(2.C)@[(1.x)/(2)]&(2.C)>[(1.x)/(8)]",
            },
          ],
          str2: [
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "2000,0",
              Ctrlpoint: "1000,500",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Semicircle_with_adjustment_4",//"نیم دایره با تنظیم 4",
          icon: g_04,
          key: "g_04",
          str1: [
            {
              Startpoint: "500,2000",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.C)#(200)",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "-1",
              Z: "0",
              Iff: "(2.C)@[(1.y)/(2)]&(2.C)>[(1.y)/(8)]",
            },
          ],
          str2: [
            {
              Startpoint: "500,2000",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,2000",
              Ctrlpoint: "0,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  nimdayere: [
    {
      sub: [
        {
          title: "Semicircle_1",//"نیم دایره 1",
          icon: t_01,
          key: "t_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,500",
              Ctrlpoint: "500,0",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "(1.x)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "1000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,500",
              Endpoint: "0,500",
              Ctrlpoint: "500,0",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "(1.x)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Semicircle_2",//"نیم دایره 2",
          icon: t_02,
          key: "t_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "0,0",
              Ctrlpoint: "500,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "(1.y)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "0,0",
              Ctrlpoint: "500,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "(1.y)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Semicircle_3",//"نیم دایره 3",
          icon: t_03,
          key: "t_03",
          str1: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "1000,0",
              Ctrlpoint: "500,500",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "(1.x)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "1000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,0",
              Endpoint: "1000,0",
              Ctrlpoint: "500,500",
              Model: "ARC",
              Code: 2,
              X: "(1.x)",
              Y: "0",
              C: "(1.x)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Semicircle_4",//"نیم دایره 4",
          icon: t_04,
          key: "t_04",
          str1: [
            {
              Startpoint: "500,1000",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,1000",
              Ctrlpoint: "0,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "(1.y)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,1000",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "500,1000",
              Ctrlpoint: "0,500",
              Model: "ARC",
              Code: 2,
              X: "0",
              Y: "(1.y)",
              C: "(1.y)/(2)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  nimKolbeiBaTanzim: [
    {
      sub: [
        {
          title: "Cottage_nine_with_adjustment_1",//"نبم کلبه ای با تنظیم 1",
          icon: k_01,
          key: "k_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.C)#[(4.x)/(10)]|(4.C)#[(4.y)/(10)]",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.y)>(3.y)",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "0,0",
              Ctrlpoint: "700,300",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(1.y)-(3.y)",
              C: "-1",
              Z: "0",
              Iff: "(4.x)>[(4.y)/(15)]&(4.y)>[(4.x)/(8)]&(4.C)@[(4.x)*(29)/(100)]&(4.C)@[(4.y)*(29)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,1000",
              Endpoint: "0,0",
              Ctrlpoint: "700,300",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(1.y)-(3.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Cottage_nine_with_adjustment_2",//"نبم کلبه ای با تنظیم 2",
          icon: k_02,
          key: "k_02",
          str1: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(4.C)#[(4.x)/(10)]|(4.C)#[(4.y)/(10)]",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)>(1.y)",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "300,300",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(3.y)-(1.y)",
              C: "-1",
              Z: "0",
              Iff: "(4.x)>[(4.y)/(15)]&(4.y)>[(4.x)/(8)]&(4.C)@[(4.x)*(29)/(100)]&(4.C)@[(4.y)*(29)/(100)]",
            },
          ],
          str2: [
            {
              Startpoint: "0,1000",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,2000",
              Endpoint: "1000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1000,0",
              Endpoint: "0,1000",
              Ctrlpoint: "300,300",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(3.y)-(1.y)",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  nimKolbei: [
    {
      sub: [
        {
          title: "Cottage_nine_1",//"نبم کلبه ای  1",
          icon: r_01,
          key: "r_01",
          str1: [
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)-(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.y)#(200)",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "146,146",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.x)",
              C: "(2.x)*(293)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,500",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)-(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "146,146",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.x)",
              C: "(2.x)*(293)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "Cottage_nine_2",//"نبم کلبه ای  2",
          icon: r_02,
          key: "r_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(3.y)#(200)",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)-(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,0",
              Ctrlpoint: "354,146",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.x)",
              C: "(2.x)*(293)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1500",
              Endpoint: "500,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "(1.y)-(2.x)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,500",
              Endpoint: "0,0",
              Ctrlpoint: "354,146",
              Model: "ARC",
              Code: 4,
              X: "(2.x)",
              Y: "(2.x)",
              C: "(2.x)*(293)/(1000)",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  yekGosheKham: [
    {
      sub: [
        {
          title: "A_bent_corner_1",//"یک گوشه خم  1",
          icon: a_01,
          key: "a_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)+(4.y)",
              C: "0",
              Z: "0",
              Iff: "(4.C)#[(4.y)/(10)]|(4.C)#[(4.x)/(10)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(4.x)>[(4.y)/(15)]&(4.y)>[(4.x)/(15)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1853,146",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(4.C)@[(4.y)*(293)/(1000)]&(4.C)@[(4.x)*(293)/(1000)]",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(3.y)+(4.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "1853,146",
              Model: "ARC",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "A_bent_corner_2",//"یک گوشه خم  2",
          icon: a_02,
          key: "a_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(2.C)#[(2.y)/(10)]|(2.C)#[(2.x)/(10)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "500,1000",
              Ctrlpoint: "146,853",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(2.x)>[(2.y)/(15)]&(2.y)>[(2.x)/(15)]",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(2.C)@[(2.y)*(293)/(1000)]&(2.C)@[(2.x)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "500,1000",
              Ctrlpoint: "146,853",
              Model: "ARC",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "A_bent_corner_3",//"یک گوشه خم  3",
          icon: a_03,
          key: "a_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "(3.C)#[(3.y)/(10)]|(3.C)#[(3.x)/(10)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(3.x)>[(3.y)/(15)]&(3.y)>[(3.x)/(15)]",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "1852,852",
              Model: "ARC",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(3.C)@[(3.y)*(293)/(1000)]&(3.C)@[(3.x)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "1500,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,1000",
              Endpoint: "2000,500",
              Ctrlpoint: "1852,852",
              Model: "ARC",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "A_bent_corner_4",//"یک گوشه خم  4",
          icon: a_04,
          key: "a_04",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "(1.C)#[(1.y)/(10)]|(1.C)#[(1.x)/(10)]",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "(1.x)>[(1.y)/(15)]&(1.y)>[(1.x)/(15)]",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(5.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "(1.C)@[(1.y)*(293)/(1000)]&(1.C)@[(1.x)*(293)/(1000)]",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "148,148",
              Model: "ARC",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "-1",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1000",
              Endpoint: "2000,1000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(5.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
  yekGosheMovarab: [
    {
      sub: [
        {
          title: "A_diagonal_corner_1",//"یک گوشه مورب  1",
          icon: e_01_01,
          key: "e_01_01",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "(5.x)+(4.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,500",
              Endpoint: "1500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "A_diagonal_corner_2",//"یک گوشه مورب  2",
          icon: e_01_02,
          key: "e_01_02",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "(4.y)+(3.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "1500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "1500,2000",
              Endpoint: "2000,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,1500",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "A_diagonal_corner_3",//"یک گوشه مورب  3",
          icon: e_01_03,
          key: "e_01_03",
          str1: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "0,0",
              Endpoint: "0,1500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,1500",
              Endpoint: "500,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "500,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "0,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "(2.x)+(3.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
        {
          title: "A_diagonal_corner_4",//"یک گوشه مورب  4",
          icon: e_01_04,
          key: "e_01_04",
          str1: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(5.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
          str2: [
            {
              Startpoint: "500,0",
              Endpoint: "0,500",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 1,
              X: "-1",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,500",
              Endpoint: "0,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 2,
              X: "0",
              Y: "-1",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "0,2000",
              Endpoint: "2000,2000",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 3,
              X: "(1.x)+(5.x)",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,2000",
              Endpoint: "2000,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 4,
              X: "0",
              Y: "(1.y)+(2.y)",
              C: "0",
              Z: "0",
              Iff: "0",
            },
            {
              Startpoint: "2000,0",
              Endpoint: "500,0",
              Ctrlpoint: "0,0",
              Model: "FRAME",
              Code: 5,
              X: "-1",
              Y: "0",
              C: "0",
              Z: "0",
              Iff: "0",
            },
          ],
        },
      ],
    },
  ],
};
